import { getFirstSelectedInvoiceStreamId } from '@/shared/components/registration/registrationHelpers';
import angular from 'angular';

angular
  .module('cloudX')
  .controller('UpdateRegistrationRelationDialogCtrl', [
    '$scope',
    '$element',
    'flySvc',
    'appUrls',
    '$http',
    'close',
    'registration',
    'showAddToDraft',
    'invoiceStreamNamesSvc',
    updateRegistrationRelationDialogCtrl,
  ]);

function updateRegistrationRelationDialogCtrl(
  $scope,
  $element,
  flySvc,
  appUrls,
  $http,
  close,
  registration,
  showAddToDraft,
  invoiceStreamNamesSvc,
) {
  const vm = this;
  if (!registration) return;
  vm.registration = registration;
  vm.showAddToDraft = showAddToDraft;
  vm.relation = null;
  vm.invoiceStreamId = null;
  vm.invoiceStreams = [];
  vm.loadingStreams = false;
  vm.addToDraftInvoice = false;
  vm.saving = false;

  vm.relationChanged = function(relation) {
    vm.relation = relation;
    vm.invoiceStreamId = null;
    vm.invoiceStreams = [];

    if (!relation || !relation.id) return;

    vm.loadingStreams = true;
    invoiceStreamNamesSvc.get(relation.id).then(
      function(streams) {
        //Ignore stale responses when the relation changed in the meantime
        if (vm.relation !== relation) return;
        vm.loadingStreams = false;
        if (!streams || !streams.length) {
          //Relation without invoice streams cannot receive registrations
          flySvc.warning('msgCannotSelectRelationWithoutInvoiceStreams');
          vm.relation = null;
          return;
        }
        vm.invoiceStreams = streams;
        vm.invoiceStreamId = getFirstSelectedInvoiceStreamId(
          vm.invoiceStreams,
          relation.invoiceStreamId,
        );
      },
      function(error) {
        if (vm.relation === relation) vm.loadingStreams = false;
        flySvc.error(error);
      },
    );
  };

  vm.save = function() {
    if (!vm.invoiceStreamId) return;
    if (vm.loadingStreams) return;
    if (vm.saving) return;
    vm.saving = true;
    $http
      .put(`${appUrls.api}/api/InvoiceRegistration/ChangeRelation`, {
        id: vm.registration.id,

        invoiceStreamId: vm.invoiceStreamId,
        addToDraftInvoice: vm.addToDraftInvoice,
      })
      .then(
        ({ data }) => {
          $element.modal('hide');
          close(data, 500);
          vm.saving = false;
        },
        error => {
          flySvc.error(error);
          vm.saving = false;
        },
      );
  };
  vm.cancel = function() {
    close(null, 500);
  };
}
